import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faUserGroup } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex } from '@modusign/design-system';

import SectionalBanner from '../SectionalBanner';

interface HostSectionalBannerProps {
  hostName: string;
}

export default function HostSectionalBanner({ hostName }: HostSectionalBannerProps) {
  return (
    <SectionalBanner
      backgroundColor="#FFFDF2"
      borderColor="boxBorderPrimaryDark"
      description={`${hostName}님이 대면서명을 확인 및 검토하는 단계입니다.`}
      headerIcon={
        <Flex
          alignItems="center"
          bg="boxBorderPrimaryDark"
          borderRadius="4px"
          color="iconNeutralLightest"
          fontSize="18px"
          height="48px"
          justifyContent="center"
          width="48px"
        >
          <FontAwesomeIcon icon={faUserGroup as IconProp} />
        </Flex>
      }
      title="진행자"
    />
  );
}
